import React, { useContext, useState, useMemo, useEffect } from 'react';
import { Table, Form, Pagination, Row, Col, Button } from 'react-bootstrap';
import moment from 'moment';
import { UserContext } from '../../context/user/ContextUser';
import { translateKey } from '../../data/diccionary';
import { useGetDta } from '../../hooks/useGetDta';
import LoadinSpin from '../ui/LoadinSpin';
import { FaAngleDown, FaAngleUp } from 'react-icons/fa';
import { useForm } from '../../hooks/useForm';

const TblOpenPay = ({ id = '' }) => {
    const [values, handleInputChange, reset, setFormValue] = useForm({
        items: 50,
        status: 'COMPLETED',
        id,
        creation: moment().format('YYYY-MM-DD'),
    });
    const { loading, data, getInfo } = useGetDta(`openpay/pagos`, values, 'PUT');
    const [expandedRow, setExpandedRow] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 30;
    const [load, setLoad] = useState(true);

    const { usersState } = useContext(UserContext);
    const { usuarios } = usersState;
    const { items, status, creation } = values;
    const toggleRow = (index) => {
        if (expandedRow === index) {
            setExpandedRow(null);
        } else {
            setExpandedRow(index);
        }
    };
    useEffect(() => {
        if (usuarios.length) setLoad(false);
    }, [usuarios]);
    useEffect(() => {
        setFormValue({ ...values, id });
    }, [id]);
    useEffect(() => {
        getInfo(`openpay/pagos`, values, 'PUT');
    }, [values]);
    const userColumn = (idcu) => {
        const clienteEncontrado = usersState?.usuarios.find((cliente) => cliente.id_cu === idcu);
        return clienteEncontrado ? clienteEncontrado.nombre : '';
    };

    const StatusColumn = (status) => {
        return (
            <span>
                {status === 'completed' && <i className="mdi mdi-check text-success fs-3 fw-bold" title="Completado" />}
                {status === 'in_progress' && (
                    <i className="mdi mdi-clock-alert text-warning fs-3 fw-bold" title="En progreso" />
                )}
                {status === 'refunded' && (
                    <i className="mdi mdi-history text-danger fs-3 fw-bold" title="Reembolsado" />
                )}
                {status === 'chargeback_pending' && (
                    <i className="mdi mdi-history text-warning fs-3 fw-bold" title="Pendiente de contracargo" />
                )}
                {status === 'chargeback_accepted' && (
                    <i className="mdi mdi-check-all text-success fs-3 fw-bold" title="Contracargo aceptado" />
                )}
                {status === 'chargeback_adjustment' && (
                    <i className="mdi mdi-eye-plus text-info fs-3 fw-bold" title="Ajuste de contracargo" />
                )}
                {status === 'charge_pending' && (
                    <i className="mdi mdi-loading text-warning fs-3 fw-bold" title="Carga pendiente" />
                )}
                {status === 'cancelled' && <i className="mdi mdi-close text-danger fs-3 fw-bold" title="Cancelado" />}
                {status === 'failed' && <i className="mdi mdi-close text-danger fs-3 fw-bold" title="Fallido" />}
                {status === 'error' && <i className="mdi mdi-close text-danger fs-3 fw-bold" title="Error" />}
            </span>
        );
    };

    const renderNestedObject = (obj) => {
        const flatObject = flattenObject(obj);
        return (
            <Table bordered hover responsive="sm" size="sm" className="nested-table">
                <thead className="table-light">
                    <tr>
                        <th>Campo</th>
                        <th>Valor</th>
                    </tr>
                </thead>
                <tbody>
                    {Object.entries(flatObject).map(([key, value], i) => (
                        <tr key={i}>
                            <td>{translateKey(key)}</td>
                            <td>{value}</td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        );
    };

    const flattenObject = (obj, parentKey = '', result = {}) => {
        for (let key in obj) {
            const newKey = parentKey ? `${parentKey}.${key}` : key;
            if (typeof obj[key] === 'object' && obj[key] !== null) {
                flattenObject(obj[key], newKey, result);
            } else {
                result[newKey] = obj[key];
            }
        }
        return result;
    };

    const searchInObject = (obj, term) => {
        for (let key in obj) {
            if (typeof obj[key] === 'object') {
                if (searchInObject(obj[key], term)) return true;
            } else if (String(obj[key]).toLowerCase().includes(term.toLowerCase())) {
                return true;
            }
        }
        return false;
    };

    const filteredData = useMemo(() => {
        return data.filter((item) => searchInObject(item, searchTerm));
    }, [searchTerm, data]);

    const paginatedData = useMemo(() => {
        const startIndex = (currentPage - 1) * itemsPerPage;
        return filteredData.slice(startIndex, startIndex + itemsPerPage);
    }, [currentPage, itemsPerPage, filteredData]);

    const pageCount = Math.ceil(filteredData.length / itemsPerPage);

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };
    if (loading || load) return <LoadinSpin />;
    return (
        <div>
            <Row className="mt-2">
                <Col md={2}>
                    <Form.Label>Mostrar items</Form.Label>

                    <Form.Select value={items} onChange={handleInputChange} name="items">
                        <option value="50">50 por página</option>
                        <option value="100">100 por página</option>
                        <option value="200">200 por página</option>
                        <option value="500">500 por página</option>
                    </Form.Select>
                </Col>
                <Col md={2}>
                    <Form.Label>Estado</Form.Label>

                    <Form.Select value={status} onChange={handleInputChange} name="status">
                        <option value="">Todos los estados</option>
                        <option value="COMPLETED">Completado</option>
                        <option value="IN_PROGRESS">En progreso</option>
                        <option value="CANCELLED">Cancelado</option>
                        <option value="FAILED">Fallido</option>
                        <option value="ERROR">Error</option>
                        {/* Add other status options as needed */}
                    </Form.Select>
                </Col>
                <Col md={2}>
                    <Form.Label>Fecha de creación</Form.Label>
                    <Form.Control type="date" value={creation} onChange={handleInputChange} name="creation" />
                </Col>

                <Col md={4} className="mt-3">
                    <Form.Control
                        type="text"
                        placeholder="Buscar..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                </Col>
            </Row>
            <Table bordered hover responsive="sm" size="sm" className="compact-table mt-2">
                <thead className="table-light">
                    <tr>
                        <th></th>
                        <th>Creación</th>
                        <th>Descripción</th>
                        <th>Nombre</th>
                        <th>Método</th>
                        <th>Monto</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {paginatedData.map((item, index) => (
                        <React.Fragment key={index}>
                            <tr onClick={() => toggleRow(index)}>
                                <td>{StatusColumn(item.status)}</td>
                                <td>{moment(item.creation_date).format('YYYY-MM-DD HH:mm:ss')}</td>
                                <td>{item.description}</td>
                                <td>{userColumn(item.customer_id)}</td>
                                <td>{translateKey(item.method)}</td>
                                <td>${item.amount}</td>
                                <td>
                                    {expandedRow === index ? (
                                        <FaAngleUp className="fs-3" />
                                    ) : (
                                        <FaAngleDown className="fs-3" />
                                    )}
                                </td>
                            </tr>
                            {expandedRow === index && (
                                <tr>
                                    <td colSpan="7">{renderNestedObject(item)}</td>
                                </tr>
                            )}
                        </React.Fragment>
                    ))}
                </tbody>
            </Table>
            <Pagination>
                <Pagination.First onClick={() => handlePageChange(1)} />
                <Pagination.Prev onClick={() => handlePageChange(Math.max(currentPage - 1, 1))} />
                {[...Array(pageCount)].map((_, pageIndex) => (
                    <Pagination.Item
                        key={pageIndex + 1}
                        active={pageIndex + 1 === currentPage}
                        onClick={() => handlePageChange(pageIndex + 1)}>
                        {pageIndex + 1}
                    </Pagination.Item>
                ))}
                <Pagination.Next onClick={() => handlePageChange(Math.min(currentPage + 1, pageCount))} />
                <Pagination.Last onClick={() => handlePageChange(pageCount)} />
            </Pagination>
        </div>
    );
};

export default TblOpenPay;
